import { Preferences } from "@capacitor/preferences"

export function useLocalSettingsController() {

    async function setSetting(settingName: string, settingValue: string): Promise<void> {
        await Preferences.set({
            key: settingName,
            value: settingValue
        })
    }

    async function getSetting(settingName: string): Promise<string | null> {
        const { value } = await Preferences.get({ key: settingName })

        return value
    }

    function setSyncSetting(settingName: string, settingValue: string): void {
        localStorage.setItem(`SETTING_${settingName}`, settingValue)
    }

    function getSyncSetting(settingName: string): string | null {
        const value = localStorage.getItem(`SETTING_${settingName}`)

        return value
    }

    return {
        setSetting,
        getSetting,
        setSyncSetting,
        getSyncSetting
    }
}
